var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"600px","width":"200px"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('v-card',[_c('div',{staticClass:"custom_container"},[_c('p',[_vm._v("Ocurrio un error")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }